import { SharingLinks } from "components/SocialSharing/SharingLinks";
import { useTranslation } from "features/translations";
import { buildWidgetInstanceId } from "features/widgets";
import { WIDGETS_REGISTRY } from "features/widgets/widgets.config";
import { Container, Heading4, ImageLite, Paragraph } from "shared/components";
import { useCollectedData } from "shared/contexts/PageData";
import { useViewMode } from "shared/contexts/ViewMode";

import styles from "./LayoutWidget081.module.scss";

export const LayoutWidget081 = ({ payload }) => {
  const { t } = useTranslation();
  const { isDesktop } = useViewMode();
  const instanceId = buildWidgetInstanceId(
    "l081",
    payload.id,
    WIDGETS_REGISTRY["LAYOUT-WIDGET"]
  );
  const { articles } = useCollectedData(instanceId, [
    { name: "articles", defaultValue: [] },
  ]);

  if (articles.length === 0) {
    return null;
  }

  const [article] = articles;

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.block}>
          <div className={styles.content}>
            <Heading4 color="dark" className={styles.title}>
              {article.title}
            </Heading4>
            {!isDesktop && (
              <ImageLite
                image={article.previewImage}
                className={styles.image}
              />
            )}
            <div className={styles.sharing}>
              <Paragraph color="grey">{t("share")}:</Paragraph>
              <SharingLinks
                appearance="brand"
                className={styles.social}
                buttonClassName={styles.button}
              />
            </div>
          </div>
          {isDesktop && (
            <ImageLite image={article.previewImage} className={styles.image} />
          )}
        </div>
      </Container>
    </div>
  );
};

export default LayoutWidget081;
